import * as React from 'react';

import { areas, velodromes } from '@/lib/race/velodrome';
import { Area } from '@/modelTypes';

import { Headline } from '../style';
import {
  AreaName,
  AreaWrapper,
  VelodromeLink,
  VelodromeNameWrapper,
  Velodromes,
  Wrapper,
} from './style';

const VelodromesTemplate: React.FC = () => {
  return (
    <>
      <Headline>競輪場一覧</Headline>
      <Wrapper>
        {(Object.values(Area) as Area[]).map(areaName => (
          <AreaWrapper key={areaName}>
            <AreaName>{areas[areaName]}</AreaName>
            <Velodromes>
              {velodromes
                .filter(
                  // TODO: 千葉競輪（vc: 32）は改修後の正式な情報がcmsにアップロードされ次第表示するようにする
                  v => v.area === areaName && !v.isClosed && v.code !== 32,
                )
                .map(v => (
                  <VelodromeLink to={`/${v.romanName}`} key={v.romanName}>
                    <VelodromeNameWrapper>
                      {v.name}競輪場
                      <span>（{v.prefecture}）</span>
                    </VelodromeNameWrapper>
                  </VelodromeLink>
                ))}
            </Velodromes>
          </AreaWrapper>
        ))}
      </Wrapper>
    </>
  );
};

export default VelodromesTemplate;
